module.exports = __webpack_public_path__ + "static/media/poweredby_mirum-design_teal.6f07655b.svg";